// extracted by mini-css-extract-plugin
module.exports = {"propertiesContent":"Properties_propertiesContent__qlCEI","propertiesAccordion":"Properties_propertiesAccordion__xhwRn","propertiesBlock":"Properties_propertiesBlock__OHh6k"};